var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modalImportFile",
          attrs: {
            id: "modal-import-file",
            size: "md",
            title: "Импорт заявки из файла",
            "ok-only": false,
            "no-fade": true,
            "button-size": "sm",
            "ok-title": "Импортировать",
            "ok-variant": "primary",
            "cancel-title": "Отменить"
          },
          on: {
            ok: _vm.okHandler,
            cancel: _vm.cancelHandler,
            close: _vm.cancelHandler,
            hide: _vm.cancelHandler
          }
        },
        [
          _c(
            "b-list-group",
            { attrs: { horizontal: "" } },
            [
              _c("b-form-file", {
                staticClass: "mr-1",
                attrs: {
                  size: "sm",
                  accept: "",
                  "browse-text": "Выбрать",
                  placeholder: "Файл не выбран"
                },
                model: {
                  value: _vm.importFile,
                  callback: function($$v) {
                    _vm.importFile = $$v
                  },
                  expression: "importFile"
                }
              }),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "danger" },
                  on: {
                    click: function($event) {
                      _vm.importFile = null
                    }
                  }
                },
                [_c("font-awesome-icon", { attrs: { icon: "times" } })],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-678dfab2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-678dfab2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/TasksImport.vue
// module id = null
// module chunks = 